
        // ✅ Import from firebase-config.js (which uses NPM)
        import { auth, db } from './firebase-config.js';
        import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

        // ========================================
        // REGISTRATION FORM HANDLING
        // ========================================

        // In your registration.js
        const registrationTimestamps = [];

        async function checkRateLimit(email) {
            const now = Date.now();
            const recent = registrationTimestamps.filter(t => now - t < 60000);

            if (recent.length > 5) {
                throw new Error('Too many registration attempts. Please wait.');
            }

            registrationTimestamps.push(now);
        }

        document.addEventListener('DOMContentLoaded', function () {
            const registerForm = document.getElementById('registerForm');

            if (registerForm) {
                registerForm.addEventListener('submit', async (e) => {
                    e.preventDefault();

                    const name = document.getElementById('regName').value.trim();
                    const email = document.getElementById('regEmail').value.trim();
                    const phone = document.getElementById('regPhone').value.trim();
                    const plan = document.getElementById('regPlan').value;
                    const message = document.getElementById('regMessage').value.trim();

                    if (!name || !email || !plan) {
                        alert('Please fill in all required fields.');
                        return;
                    }

                    // Show loading state
                    const submitBtn = registerForm.querySelector('button[type="submit"]');
                    const originalText = submitBtn.innerHTML;
                    submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Registering...';
                    submitBtn.disabled = true;

                    try {
                        // Save to Firebase
                        const docRef = await addDoc(collection(db, 'members'), {
                            name: name,
                            email: email,
                            phone: phone || '',
                            plan: plan,
                            message: message || '',
                            startDate: new Date().toISOString().split('T')[0],
                            expiryDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                        });

                        console.log('✅ Member registered with ID:', docRef.id);

                        // ✅ REDIRECT TO SUCCESS PAGE WITH MEMBER DATA
                        const successUrl = `registration-success.html?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone || 'Not provided')}&plan=${encodeURIComponent(plan)}`;
                        window.location.href = successUrl;

                    } catch (error) {
                        console.error('❌ Registration error:', error);
                        alert('There was an error with your registration. Please try again.');

                        // Reset button
                        submitBtn.innerHTML = originalText;
                        submitBtn.disabled = false;
                    }
                });
            }
        });
    